import { connect } from 'react-redux';
import Cart        from '../components/Cart';
import { onChangeParameterAndQuote as onChangeParameter } from '../actions/QuoteActions';

const mapStateToProps = state => ({
  parameters: state.get('parameters'),
  quote     : state.get('quote'),
  quoteStep : state.get('quoteStep'),
});

const mapActionsToProps = {onChangeParameter};

export default connect(mapStateToProps, mapActionsToProps)(Cart);
